import { fetchChangeChecklists } from '@gp/services/changeLog';
import {
  // formatFilterFetchParams,
  formatSortFetchParams,
} from '../utils';

import type { SortBy } from 'tea-component/lib/table/addons';
import type {
  // IPipelineChangeChecklistFilterConditionsVO,
  // IPipelineChangeChecklistFilterVO,
  IPipelineChangeChecklistRecordDTO,
  IPipelineChangeChecklistRecordVO,
} from '@gp/types/changeLog';

export const getSearchList = async (
  payload?: { projectName?: string },
  params?: {
    // filterConditions?: IPipelineChangeChecklistFilterConditionsVO;
    // filter?: IPipelineChangeChecklistFilterVO;
    sort?: SortBy<IPipelineChangeChecklistRecordVO>[];
  },
): Promise<IPipelineChangeChecklistRecordDTO[]> => {
  const { projectName } = payload || {};
  const {
    // filterConditions,
    // filter,
    sort,
  } = params || {};
  // const filterParams = formatFilterFetchParams(filter, filterConditions);
  const sortParams = formatSortFetchParams(sort);
  const res = await fetchChangeChecklists({
    granularity: 'month',
    start_date: '',
    end_date: '',
    priority: [],
    pteam: [],
    stage: [],
    // ...filterParams,
    ...sortParams,
    // 搜索
    // @ts-ignore
    search_type: 'dim',
    // 搜索
    search: projectName || '',
    project_ids: [],
    page_num: 0,
    page_size: 0,
  });
  return res?.data?.list || [];
};
